var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('section',{staticClass:"section",staticStyle:{"min-height":"500px"}},[_c('div',{staticClass:"container"},[_c('div',{},[_c('h3',[_vm._v("404")]),_c('p',{staticClass:"lead"},[_vm._v("Page not found")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }